import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../lib/api";

const RelatedColourways = ({ product, selectedColour, onPick }) => {
  const navigate = useNavigate();
  // Cache the related list across renders — colourways only change when the
  // product or selectedColour changes, so re-filtering on every parent re-render
  // is wasted work.
  const related = useMemo(
    () =>
      product.colourways.filter((c) => c.slug !== selectedColour.slug).slice(0, 4),
    [product.colourways, selectedColour.slug]
  );
  return (
    <section className="container-x py-16">
      <div className="flex items-end justify-between mb-8">
        <h2 className="font-display uppercase text-3xl md:text-4xl tracking-tightest font-bold">
          More colourways
        </h2>
        <button
          onClick={() => navigate("/shop")}
          className="text-[11px] tracking-[0.18em] uppercase font-bold underline"
        >
          View all
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-line border border-line">
        {related.map((c) => (
            <button
              key={c.slug}
              type="button"
              onClick={() => onPick(c)}
              className="bg-white text-left"
              data-testid={`related-${c.slug}`}
            >
              <div
                className="aspect-square border-b border-line flex items-center justify-center"
                style={{ backgroundColor: c.hex }}
              >
                <p
                  className={`font-display uppercase text-xl ${
                    c.slug === "blackout-white" ? "text-white" : "text-ink"
                  }`}
                >
                  Pritch
                </p>
              </div>
              <div className="p-4">
                <p className="text-[13px] uppercase tracking-widest font-medium">{c.name}</p>
                <p className="mono text-xs text-mute mt-1">{formatPrice(product.price)}</p>
              </div>
            </button>
          ))}
      </div>
    </section>
  );
};

export default RelatedColourways;
